import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { gray, brand } from '../themePrimitives';

export const inputsCustomizations = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        position: 'relative',
        borderRadius: 6,
        backgroundColor: (theme.vars || theme).palette.background.default,
        transition: 'border-color 120ms ease-in-out',

        // Let notchedOutline handle the border
        [`& .MuiOutlinedInput-notchedOutline`]: {
          borderColor: (theme.vars || theme).palette.divider,
        },

        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: gray[400],
        },

        [`&.${outlinedInputClasses.focused} .MuiOutlinedInput-notchedOutline`]: {
          borderColor: brand[400],
        },

        [`&.${outlinedInputClasses.error} .MuiOutlinedInput-notchedOutline`]: {
          borderColor: theme.palette.error.main,
        },
      }),

      notchedOutline: {
        // DO NOT remove the border completely
        borderWidth: '1px !important',
      },

      input: {
        padding: '12px 14px',
        fontSize: '0.875rem',
      },
    },
  },
};
